import { useCallback, useState } from "react";

import { importZip, validateZip } from "../importContentUtils";
import {
  IMPORT_TYPES,
  importJsonPackage,
  validateJsonPackage,
} from "../jsonImportUtils";

// Holds what validating a package leaves behind for the follow-up import: the
// extracted QTI files, or the key of the JSON package already uploaded to S3.
const useImportPackage = (client) => {
  const [extractedFiles, setExtractedFiles] = useState([]);
  const [packageS3Key, setPackageS3Key] = useState(null);

  const validatePackage = useCallback(
    async ({ file, importType, metadata, program }) => {
      if (importType === IMPORT_TYPES.JSON) {
        const { data, s3Key } =
          await validateJsonPackage(client)(program)(metadata)(file);
        setPackageS3Key(s3Key);
        return data;
      }
      const [data, zipContents] = await validateZip(client)(program)(file);
      setExtractedFiles(zipContents);
      return data;
    },
    [client],
  );

  const importPackage = useCallback(
    async ({ file, importType, metadata, program, validationResults }) => {
      if (importType === IMPORT_TYPES.JSON)
        return importJsonPackage(client)(program)(metadata)({
          file,
          s3Key: packageS3Key,
        });
      return importZip(client)(program)({
        contentArea: metadata.contentArea || null,
        contentSpecialist: metadata.contentSpecialist,
        developmentState: metadata.developmentState || null,
        itemWriter: metadata.itemWriter,
      })({ file, validationResults })(extractedFiles);
    },
    [client, extractedFiles, packageS3Key],
  );

  return { importPackage, validatePackage };
};

export { useImportPackage };
